import script from "./field-validation-free-text-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./field-validation-free-text-area.vue?vue&type=script&setup=true&lang=ts"

import "./field-validation-free-text-area.vue?vue&type=style&index=0&id=bb61a298&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb61a298"]])

export default __exports__